// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/Roboto-Thin.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/Roboto-ThinItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/fonts/Roboto-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/fonts/Roboto-LightItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/fonts/Roboto-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/fonts/Roboto-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../assets/fonts/Roboto-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../assets/fonts/Roboto-MediumItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../assets/fonts/Roboto-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../assets/fonts/Roboto-BoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../assets/fonts/Roboto-Black.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../../assets/fonts/Roboto-BlackItalic.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Roboto";
  font-weight: 100;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 100;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 300;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 300;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 400;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 400;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 500;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 500;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 700;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 700;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 900;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 900;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("truetype");
}
.serviceSelector {
  font-family: inherit;
  margin: 0 auto;
  padding: 1rem 1rem 0.5rem;
  color: rgb(80, 80, 80);
}
.serviceSelector .sectionTitle {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  margin: 0 0 0.75rem;
  font-size: 1rem;
  font-weight: 700;
  color: #333;
}
.serviceSelector .serviceList {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  margin-bottom: 1rem;
}
.serviceSelector .service {
  position: relative;
  padding: 0.75rem 0.9rem;
  cursor: pointer;
  border-radius: 0.9rem;
  background-color: #ffffff;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease;
}
.serviceSelector .service:active:not(:disabled) {
  box-shadow: 0 0.125rem 0.5rem #363c56;
  transform: translateY(0.125rem);
  opacity: 0.75;
}
.serviceSelector .service .service-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.25rem;
}
.serviceSelector .service .service-header .title {
  font-weight: 600;
  font-size: 0.9rem;
  color: #222;
  flex: 1 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.serviceSelector .service .service-header .duration {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  font-size: 0.7rem;
  font-weight: 600;
  background: rgba(81, 85, 146, 0.1);
  padding: 0.2rem 0.55rem;
  border-radius: 20px;
  color: #515592;
  white-space: nowrap;
  flex-shrink: 0;
}
.serviceSelector .service .address {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.72rem;
  color: #999;
}
.serviceSelector .service .address svg {
  flex-shrink: 0;
  color: #bbb;
}
.serviceSelector .service .checkmark {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 1.1rem;
  height: 1.1rem;
  background: rgba(255, 255, 255, 0.25);
  border-radius: 50%;
  color: #ffffff;
}
.serviceSelector .service.selected {
  background-color: #515592;
  box-shadow: 0 6px 18px rgba(81, 85, 146, 0.3);
}
.serviceSelector .service.selected .service-header .title {
  color: #ffffff;
}
.serviceSelector .service.selected .duration {
  background: rgba(255, 255, 255, 0.2);
  color: #ffffff;
}
.serviceSelector .service.selected .address {
  color: rgba(255, 255, 255, 0.75);
}
.serviceSelector .service.selected .address svg {
  color: rgba(255, 255, 255, 0.75);
}`, "",{"version":3,"sources":["webpack://./src/assets/Theme/variables/_fonts.scss","webpack://./src/components/ServiceSelector/ServiceSelector.scss","webpack://./src/assets/Theme/variables/_colorSchema.scss","webpack://./src/assets/Theme/mixins/_click-animation.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACCF;ADEA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACAF;ADGA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACDF;ADIA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACFF;ADKA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACHF;ADMA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACJF;ADOA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACLF;ADQA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACNF;ADSA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACPF;ADUA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACRF;ADWA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gEAAA;ACTF;ADYA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gEAAA;ACVF;AAnEA;EACE,oBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBCCe;ADoEjB;AAnEE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AAqEJ;AAlEE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,mBAAA;AAoEJ;AAjEE;EAEE,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,qBAAA;EACA,yBClCI;EDmCJ,0CAAA;EACA,yBAAA;AAkEJ;AErGE;EACE,qCAAA;EACA,+BAAA;EACA,aAAA;AFuGJ;AArEI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;AAuEN;AArEM;EACE,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,SAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAuER;AApEM;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,kCAAA;EACA,uBAAA;EACA,mBAAA;EACA,cA9DQ;EA+DR,mBAAA;EACA,cAAA;AAsER;AAlEI;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AAoEN;AAlEM;EACE,cAAA;EACA,WAAA;AAoER;AAhEI;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,cAAA;EACA,qCAAA;EACA,kBAAA;EACA,cC5FE;AD8JR;AA/DI;EACE,yBA9FU;EA+FV,6CAAA;AAiEN;AA/DM;EACE,cCpGA;ADqKR;AA9DM;EACE,oCAAA;EACA,cCzGA;ADyKR;AA7DM;EACE,gCAAA;AA+DR;AA7DQ;EACE,gCAAA;AA+DV","sourcesContent":["@font-face {\n  font-family: 'Roboto';\n  font-weight: 100;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Thin.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 100;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-ThinItalic.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 300;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Light.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 300;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-LightItalic.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 400;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Regular.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 400;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-Italic.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 500;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Medium.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 500;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-MediumItalic.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 700;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Bold.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 700;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-BoldItalic.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 900;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Black.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 900;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-BlackItalic.ttf') format('truetype');\n}\n","@import '../../assets/Theme';\n\n$brand_primary: #515592;\n\n.serviceSelector {\n  font-family: inherit;\n  margin: 0 auto;\n  padding: 1rem 1rem 0.5rem;\n  color: $unselectedText;\n\n  .sectionTitle {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.4rem;\n    margin: 0 0 0.75rem;\n    font-size: 1rem;\n    font-weight: 700;\n    color: #333;\n  }\n\n  .serviceList {\n    display: flex;\n    flex-direction: column;\n    gap: 0.6rem;\n    margin-bottom: 1rem;\n  }\n\n  .service {\n    @include click-animation;\n    position: relative;\n    padding: 0.75rem 0.9rem;\n    cursor: pointer;\n    border-radius: 0.9rem;\n    background-color: $white;\n    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.05);\n    transition: all 0.2s ease;\n\n    .service-header {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      gap: 0.5rem;\n      margin-bottom: 0.25rem;\n\n      .title {\n        font-weight: 600;\n        font-size: 0.9rem;\n        color: #222;\n        flex: 1;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n      }\n\n      .duration {\n        display: flex;\n        align-items: center;\n        gap: 0.3rem;\n        font-size: 0.7rem;\n        font-weight: 600;\n        background: rgba(81, 85, 146, 0.1);\n        padding: 0.2rem 0.55rem;\n        border-radius: 20px;\n        color: $brand_primary;\n        white-space: nowrap;\n        flex-shrink: 0;\n      }\n    }\n\n    .address {\n      display: flex;\n      align-items: center;\n      gap: 0.35rem;\n      font-size: 0.72rem;\n      color: #999;\n\n      svg {\n        flex-shrink: 0;\n        color: #bbb;\n      }\n    }\n\n    .checkmark {\n      display: flex;\n      flex-shrink: 0;\n      align-items: center;\n      justify-content: center;\n      width: 1.1rem;\n      height: 1.1rem;\n      background: rgba(255, 255, 255, 0.25);\n      border-radius: 50%;\n      color: $white;\n    }\n\n    &.selected {\n      background-color: $brand_primary;\n      box-shadow: 0 6px 18px rgba($brand_primary, 0.3);\n\n      .service-header .title {\n        color: $white;\n      }\n\n      .duration {\n        background: rgba(255, 255, 255, 0.2);\n        color: $white;\n      }\n\n      .address {\n        color: rgba($white, 0.75);\n\n        svg {\n          color: rgba($white, 0.75);\n        }\n      }\n    }\n  }\n}","$white: #ffffff;\n$text_dark: #2c2c2e;\n$text_gray: rgb(178, 181, 188);\n$buttonBg: #363c56;\n$errorText: #f70d1a;\n$buttonLinearBg: linear-gradient(to right, #1d2239, #4657a2, #1d2239);\n$msgDisable: rgb(150, 150, 150);\n$disabled: rgb(200, 200, 200);\n$light_gray: rgb(241, 241, 241);\n$unselectedText: rgb(80, 80, 80);\n$locationBnt: rgb(255, 255, 0);\n$spinner_blue: #3498db;\n\n$bg_unselected: rgb(188, 188, 224);\n$bg_selected: #559f5b;\n$bg_pending: #ccb137;\n$bg_frame: rgba(0, 0, 0, 0.6);\n\n$shadow: #2c2c2e5e;\n$light_shadow: rgba(49, 49, 52, 0.2);\n$highlighter: #eeff6e;\n$appt_bg: rgb(249, 249, 249);\n$red_bg: #cb101a;\n\n$notification_success: #4fae00;\n$notification_warning: #e4dd00;\n$notification_error: #be1000;\n","@mixin click-animation() {\n  &:active:not(:disabled) {\n    box-shadow: 0 0.125rem 0.5rem $buttonBg;\n    transform: translateY(0.125rem);\n    opacity: 0.75;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
